import React, { useState, useRef, useEffect, useContext, useCallback } from 'react';
import {
  Wrapper,
  Placeholder,
  IconWrapper,
  Ubigeo,
  ContentModal,
  IconClose,
  LoaderWrapper,
  InputWrapper
} from './styled';
import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';
import { PredictiveResultsModal } from './PredictiveResultsModal';
import { Modal } from '@app/src/common/Modal';
import { PredictiveContext } from './PredictiveConstructor';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDistrictAction } from '@app/src/views/StepOne/form';

const MIN_CHARACTERS = 3;

export const SearchInputModal: React.FC = () => {
  const {
    handleChange,
    handleClickClose,
    defaultUbigeo,
    handleBlurInput,
    error,
    disabled,
    input
  } = useContext(PredictiveContext);
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.district.isFetching);
  const [value, setValue] = useState('');
  const [currentValue, setCurrentValue] = useState('');
  const [activeSuggestion, setActiveSuggestion] = useState(-1);
  const [formatValue, setFormatValue] = useState([]);
  const refWrapper = useRef(null);
  const refClose = useRef(null);
  const [displayModal, setDisplayModal] = useState(false);
  const refInput = useRef(null);
  const districts = useSelector(state => state.district.data)
  const messageUbigeo = useSelector(state => state.district.message);
  const inputValue = useSelector(state => state.district.inputValue);

  useEffect(() => {
    if (value) {
      let formatValue = value.split(',');
      setFormatValue(formatValue)
    }
    if (currentValue.length >= MIN_CHARACTERS && currentValue !== value && !isLoading) {
      dispatch(fetchDistrictAction(currentValue));
    }
  }, [currentValue, value]);

  useEffect(() => {
    if (currentValue !== inputValue && inputValue !== '' && isLoading) {
      dispatch(fetchDistrictAction(currentValue));
    }
  }, [inputValue]);

  useEffect(() => {
    if (defaultUbigeo) {
      setValue(defaultUbigeo);
      setCurrentValue(defaultUbigeo);
    } else {
      clearInput();
    }
  }, [defaultUbigeo]);

  useEffect(() => {
    if(districts[activeSuggestion]) {
      setValue(districts[activeSuggestion].data.location);
      setCurrentValue(districts[activeSuggestion].data.location);
      refInput.current.style.display = 'none';
    }
  }, [activeSuggestion]);

  useEffect(() => {
    if (displayModal) {
      if (value) {
        refInput.current.style.display = 'none';
      }
    }
  }, [displayModal, value]);

  const handleChangeRadioInput = (_value:string, index: number) => {
    setActiveSuggestion(index);
    handleChange && handleChange(districts[index]);
    setTimeout(() => {
      setDisplayModal(false);
    }, 200)
  }

  const handleClickCloseModal = () => {
    setDisplayModal(false);
  }

  const handleClickWrapper = useCallback(() => {
    if (districts && districts.length === 0) {
      dispatch(fetchDistrictAction('lim'));
    }
    setDisplayModal(true);
  }, [districts])

  const handleChangeInput = (e) => {
    setCurrentValue(e.target.value);
  }

  const handleClickClear = () => {
    refInput.current.style.display = 'block';
    clearInput();
    refInput.current.focus();
    handleClickClose && handleClickClose();
  }

  const handleClickCloseOutModal = (e: React.MouseEvent) => {
    e.stopPropagation();
    setActiveSuggestion(-1);
    handleClickClose && handleClickClose();
  }

  const handleBlur = () => {
    if (activeSuggestion === -1) {
      setValue('');
      handleChange && handleChange(null);
      handleBlurInput && handleBlurInput();
    }
  }

  const clearInput = () => {
    setValue('');
    setCurrentValue('');
    setActiveSuggestion(-1);
  }

  return (
  <React.Fragment>
    <Wrapper
      ref={refWrapper}
      onClick={() => (!disabled && !isLoading) && handleClickWrapper()}
      borderColor={`1px solid ${error ? 'red' : COLORS.GRAY}`}>
      <IconWrapper>
        <Icon data-name="icon-map" width="18" height="18" fill={COLORS.GRAY_PLACEHOLDER} />
      </IconWrapper>
      {
        value ?
          <React.Fragment>
            <Ubigeo>
            <span>{formatValue[0]}</span>{formatValue[1] ? `, ${formatValue[1]}` : ''} {formatValue[2] ? `, ${formatValue[2]}` : ''}
            </Ubigeo>
            {!disabled && !isLoading && <IconClose onClick={handleClickCloseOutModal}>
              <Icon data-name="icon-close-bold" width="18" height="18" fill={COLORS.GRAY} />
            </IconClose>}
          </React.Fragment>
          :
          <Placeholder>
            <span>Ej. Miraflores</span>, Lima, Lima
          </Placeholder>
      }
      {
        isLoading &&
        <LoaderWrapper>
            <Icon data-name='icon-circle' fill='#ccc' width={'17'} height={'17'} />
        </LoaderWrapper>
      }
      </Wrapper>
      <Modal show={displayModal} closeModal={handleClickCloseModal} customBody>
        <ContentModal>
          <Wrapper>
            <IconWrapper>
              <Icon data-name="icon-map" width="18" height="18" fill={COLORS.GRAY_PLACEHOLDER} />
            </IconWrapper>
            <InputWrapper
              {...input}
              onChange={handleChangeInput}
              onBlur={handleBlur}
              ref={refInput}
              value={currentValue}
              autoComplete="off"
              disabled={disabled}
            />
            {
              (currentValue === '') &&
                <Placeholder>
                  <span>Ej. Miraflores</span>, Lima, Lima
                </Placeholder>
            }
            {
              (currentValue && currentValue === value) &&
                <Ubigeo>
                  <span>{formatValue[0]}</span>{formatValue[1] ? `, ${formatValue[1]}` : ''} {formatValue[2] ? `, ${formatValue[2]}` : ''}
                </Ubigeo>
            }
            {
              isLoading &&
              <LoaderWrapper>
                  <Icon data-name='icon-circle' fill='#ccc' width={'17'} height={'17'} />
              </LoaderWrapper>
            }
            {
              (currentValue !== '' || value !== '') && !isLoading &&
                <IconClose onClick={handleClickClear} ref={refClose}>
                  <Icon data-name="icon-close-bold" width="18" height="18" fill={COLORS.GRAY} />
                </IconClose>
            }
          </Wrapper>
          <PredictiveResultsModal
            activeItem={activeSuggestion}
            dataList={districts}
            showFirstItems={5}
            handleChange={handleChangeRadioInput}
            message={messageUbigeo}
          />
        </ContentModal>
      </Modal>
  </React.Fragment>
)};
